import { Chip, IconButton, Stack } from '@mui/material';
import { AddDealInput } from 'api';
import { useWatch, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { DealPortEditorContent } from 'components/DealPortEditorContent';
import { TXT_READY_TO_SYNC, TXT_UNLOADING_PORT } from '../../../../../shared/translations';
import { useContext } from 'react';
import { DealWizardContext } from './DealWizard';
import capitalizeEveryWord from '../../../../../shared/stringUtils/capitalizeEveryWord';

interface DealWizardUnlodingPortProps {
  index: number;
  handleRemove: (index: number) => void;
}

export const DealWizardUnlodingPort = (props: DealWizardUnlodingPortProps) => {
  const { control } = useFormContext<AddDealInput>();
  const { isDisabled } = useContext(DealWizardContext);
  const { t } = useTranslation();

  const watchUnloadingPort = useWatch({
    control,
    name: `unloadingPorts.${props.index}`
  });

  return (
    <fieldset>
      <legend>{watchUnloadingPort.port?.name || `${t(TXT_UNLOADING_PORT).toUpperCase()} #${props.index + 1}`}</legend>
      <Stack
        spacing={2}
        direction="row"
        sx={(theme) => ({
          mb: theme.spacing(1),
          width: '100%'
        })}
        justifyContent="flex-end"
        alignItems="center"
      >
        {!!watchUnloadingPort.pendingToSync ? (
          <Chip label={capitalizeEveryWord(t(TXT_READY_TO_SYNC))} color="success" variant="outlined" />
        ) : null}
        <IconButton
          aria-label={`delete-unloading-port-${props.index}`}
          onClick={() => props.handleRemove(props.index)}
          disabled={isDisabled}
        >
          <DeleteIcon />
        </IconButton>
      </Stack>
      <DealPortEditorContent index={props.index} />
    </fieldset>
  );
};
